import { render, staticRenderFns } from "./moviesinfo-add-or-update.vue?vue&type=template&id=7b85ce90"
import script from "./moviesinfo-add-or-update.vue?vue&type=script&lang=js"
export * from "./moviesinfo-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports